// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarCircleOutlinedSvg from "@fishx/icons-svg/es/asn/DollarCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var DollarCircleOutlined = function DollarCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleOutlinedSvg
  }));
};

DollarCircleOutlined.displayName = 'DollarCircleOutlined';
export default React.forwardRef(DollarCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DollarCircleOutlined.js
// module id = 2442
// module chunks = 0